import React from 'react'

import { CLIENT_SELF_PAY_STATUS } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'
import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'
import { Programs } from '@lyrahealth-inc/shared-app-logic/src/features/programConfigs/programConfigs'
import { ClientObject } from '@lyrahealth-inc/shared-app-logic/src/models/client/Client'
import { LTProgramName } from '@lyrahealth-inc/shared-app-logic/src/models/programs/Programs'
import { SelfPayContinuationOfCareBanner } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/selfPayContinuationOfCareBanner/SelfPayContinuationOfCareBanner'

import { getClientSessionsRemaining } from '../../../../../common/utils/utils'

export const useSelfPayContinuationOfCareBanner = (
  clientDetails: ClientObject | undefined,
  programName: LTProgramName | undefined,
): React.ReactNode | null => {
  const { isSelfPayEnabled } = useFlags()

  if (
    !isSelfPayEnabled ||
    !clientDetails?.customer_support_self_pay ||
    !Programs.getProgramConfigByName(programName)?.selfPayEligible
  ) {
    return null
  }

  const sessionsRemaining = getClientSessionsRemaining(clientDetails, programName)
  const isClientSelfPayEligible = clientDetails?.self_pay_status === CLIENT_SELF_PAY_STATUS.ELIGIBLE

  if (!isClientSelfPayEligible || sessionsRemaining > 1) {
    return null
  }

  return <SelfPayContinuationOfCareBanner clientDetails={clientDetails} sessionsRemaining={sessionsRemaining} />
}
